import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {SearchDay} from '../../SearchDay';

import {useOptions} from './';

const defaultOptions = {
    actionLocation: undef,
    alertTemplateComponent: undef,
    alertTemplateData: undef,
    allowHighlight: false,
    centered: undef,
    consolidateInputs: undef,
    dateFormatOptions: {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    },
    dayData: undef,
    dayTemplateComponent: SearchDay,
    disableTextInput: undef,
    displayYearFirst: undef,
    enableSameDayDateRange: undef,
    fadeOutDuration: 0,
    id: 'dates',
    inputIcon1Name: 'check-in',
    inputIcon2Name: 'check-out',
    inputName1: 'check-in',
    inputName2: 'check-out',
    maxDate: undef,
    minDate: undef,
    parentNode: undef,
    placement: undef,
    positionIconRight: undef,
    scrollNode: undef,
    showArrow: false,
    showInputIcon1: undef,
    showInputIcon2: undef,
    splitInputs: undef,
    wdioPrefix: undef
};

function useDatesOptions(props) {
    const {
        datesOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useDatesOptions};
